/**
 * PATH: apps/qa/src/pages/JobQaJobPage.tsx
 * FILE_ID: QA-PAGE-JOB-QA-001
 * PURPOSE: Open a job's QA screen even when the job has no QA yet.
 */
import { useParams } from 'react-router-dom'
import { JobQaRecordWorkspace } from './record-detail/JobQaRecordWorkspace'

export default function JobQaJobPage() {
  const { jobNumber } = useParams<{ jobNumber: string }>()
  const jobId = Number(jobNumber)
  if (!Number.isFinite(jobId)) {
    return <p className="p-4 text-sm text-muted-foreground">Could not open this job.</p>
  }
  return <JobQaRecordWorkspace jobId={jobId} />
}
